export const maintenanceData = [
  {
    key: "1",
    CAR: "Ford Endeavour",
    MODAL: "Sedan",
    CARIMAGE: "car-01.jpg",
    STARTDATE: "24 Jan 2025",
    ENDDATE: "26 Jan 2025 ",
    ENDTIME: "10:30 AM",
    ODOMETER: "12,215 km",
    STATUS: "Completed",
  },
  {
    key: "2",
    CAR: "Ferrari 458 MM",
    MODAL: "Convertible",
    CARIMAGE: "car-02.jpg",
    STARTDATE: "19 Dec 2024",
    ENDDATE: "20 Dec 2024",
    ENDTIME: "10:30 AM",
    ODOMETER: "12,215 km",
    STATUS: "Inprogress",
  },
  {
    key: "3",
    CAR: "Ford Mustang",
    MODAL: "Coupe",
    CARIMAGE: "car-03.jpg",
    STARTDATE: "11 Dec 2024",
    ENDDATE: "13 Dec 2024",
    ENDTIME: "10:30 AM",
    ODOMETER: "11,345 km",
    STATUS: "Completed",
  },
  {
    key: "4",
    CAR: "Toyota Tacoma 4",
    MODAL: "Hatchback",
    CARIMAGE: "car-04.jpg",
    STARTDATE: "29 Nov 2024",
    ENDDATE: "30 Nov 2024",
    ENDTIME: "10:30 AM",
    ODOMETER: "10,675 km",
    STATUS: "Planned",
  },
  {
    key: "5",
    CAR: "Chevrolet Truck",
    MODAL: "Sedan",
    CARIMAGE: "car-05.jpg",
    STARTDATE: "03 Nov 2024",
    ENDDATE: "05 Nov 2024",
    ENDTIME: "10:30 AM",
    ODOMETER: "19,015 km",
    STATUS: "Completed",
  },
  {
    key: "6",
    CAR: "Etios Carmen",
    MODAL: "Hatchback",
    CARIMAGE: "car-06.jpg",
    STARTDATE: "31 Oct 2024",
    ENDDATE: "01 Oct 2024",
    ENDTIME: "10:30 AM",
    ODOMETER: "12,098 km",
    STATUS: "Inprogress",
  },
  {
    key: "7",
    CAR: "Acura Sport",
    MODAL: "Crossover",
    CARIMAGE: "car-07.jpg",
    STARTDATE: "15 Oct 2024",
    ENDDATE: "17 Oct 2024",
    ENDTIME: "10:30 AM",
    ODOMETER: "10,315 km",
    STATUS: "Completed",
  },
  {
    key: "8",
    CAR: "Kia Soul 2016",
    MODAL: "Delivery",
    CARIMAGE: "car-08.jpg",
    STARTDATE: "26 Sep 2024",
    ENDDATE: "27 Sep 2024",
    ENDTIME: "10:30 AM",
    ODOMETER: "14,432 km",
    STATUS: "Planned",
  },
  {
    key: "9",
    CAR: "Camaro",
    MODAL: "Station Wagon",
    CARIMAGE: "car-09.jpg",
    STARTDATE: "01 Sep 2024",
    ENDDATE: "03 Sep 2024",
    ENDTIME: "10:30 AM",
    ODOMETER: "15,215 km",
    STATUS: "Completed",
  },
  {
    key: "10",
    CAR: "Toyota Camry",
    MODAL: "Mini Van",
    CARIMAGE: "car-10.jpg",
    STARTDATE: "15 Aug 2024",
    ENDDATE: "16 Aug 2024",
    ENDTIME: "10:30 AM",
    ODOMETER: "13,582 km",
    STATUS: "Completed",
  },
];
